module.exports = __webpack_public_path__ + "img/img_rank_03.bc9d2b4a.svg";